module.exports = __webpack_public_path__ + "static/media/phillip.2868e700.jpeg";